export function downloadJson(filename: string, json: string) {
  const blob = new Blob([json], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();

  // Some browsers start reading the blob after click() returns.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
